import type { AsyncData } from "#app";
import type { IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelGETKnowledgeRequest, IModelGETKnowledgeResponse } from "./dto/knowledge.dto";


export class KnowledgeRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getKnowledgePreset(params: IModelGETKnowledgeRequest): Promise<AsyncData<IModelResponse<IModelGETKnowledgeResponse[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge-association/knowledge-preset`, this.configService, {
      params,
    });
    return dataResult;
  }

  async deleteKnowledgePreset(id: string | number): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge-association/knowledge-preset/${id}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }

  async getKnowledgeDetail(id: string): Promise<AsyncData<IModelResponse<IModelGETKnowledgeResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge/${id}`, this.configService);
    return dataResult;
  }

  async createKnowledge(data: any): Promise<AsyncData<IModelResponse<IModelGETKnowledgeResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge`, this.configService, {
      method: 'POST',
      body: {
        data
      }
    });
    return dataResult;
  }

  async updateKnowledge(id: string, data: any): Promise<AsyncData<IModelResponse<IModelGETKnowledgeResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge`, this.configService, {
      method: 'PUT',
      body: {
        data: {
          ...data,
          id
        }
      }
    });
    return dataResult;
  }
}

